import styled from 'styled-components'

export const Background = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
`

export const Modal = styled.div`
  max-width: 505px;
  width: 100%;
  height: min-content;
  padding: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 16px;
  filter: drop-shadow(4px 4px 10px rgba(0, 0, 0, 0.15));

  //Modal breakpoints

  @media (min-width: 1440px) {
    max-width: 570px;
  }

  @media (max-width: 538px) {
    width: 90%;
  }
`

export const Container = styled.div`
  width: 95%;
  height: 95%;
  display: flex;
  align-items: center;
  gap: 2rem;
  justify-content: center;
  flex-direction: column;

  p {
    margin: 0;
  }

  .closeModalIcon {
    font-size: 32px;
  }

  .qrCodeText {
    width: 100%;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-direction: column;
  }

  .qrCodeText h4 {
    width: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 21px;
    color: #393939;
  }

  .TextInstruction {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 16px;
    color: #4a4a4a;
    margin-bottom: 0.5rem;
  }

  .CloseModal {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: end;
    color: #394a64;
  }

  @media (max-width: 538px) {
    .qrCodeText h4 {
      font-size: 16px;
    }

    .TextInstruction {
      font-size: 12px;
      font-weight: 600;
    }
  }

  @media (max-width: 375px) {
    .qrCodeText h4 {
      font-size: 14px;
    }
  }
`

export const PaymentInfo = styled.div`
  width: 100%;
  height: min-content;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;

  .qrCodeDiv {
    width: 100%;
    height: 7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(127, 209, 203, 0.2);
    border-radius: 5px 5px 0px 0px;
  }

  @media (min-width: 1440px) {
    .qrCodeDiv {
      height: 10.5rem;
    }
  }

  .grayDivs {
    width: 100%;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(127, 209, 203, 0.2);
  }

  .copyToClipboard {
    width: 100%;
    height: 100%;
    border: none;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 120%;
    /* or 19px */
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: -0.01em;
    gap: 0.5rem;
    /* Dark Gray/100 */
    color: #4a4a4a;
  }

  .copyToClipboard svg {
    font-size: 20px;
  }

  .qrCode {
    width: 7rem;
    height: 93%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffff;
  }

  @media (min-width: 1440px) {
    .qrCode {
      width: 9.7rem;
    }
  }

  .qrCode svg {
    width: 100%;
    height: 96.1%;
  }

  .qrCode path {
    width: 100%;
    height: 97%;
  }

  .pixNumber {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 120%;
    /* or 19px */
    max-width: 80%;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: -0.01em;
    /* Dark Gray/100 */
    color: #4a4a4a;
  }
`
